var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var card = {
    background: '#ffffff',
    border: "1px solid ".concat('#DFE4E8'),
    borderRadius: 8,
    boxShadow: '0px 2px 4px 0.5px rgba(50, 62, 72, 0.08)',
    display: 'block',
    padding: 8,
};
export var collapsibleCard = {
    background: '#ffffff',
    border: "1px solid ".concat('#DFE4E8'),
    borderRadius: 8,
    boxShadow: '0px 2px 4px 0.5px rgba(50, 62, 72, 0.08)',
    display: 'block',
    padding: 8,
};
export var collapisbleCardClosed = __assign(__assign({}, collapsibleCard), { div: {
        border: 'none',
    } });
export var footer = {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'flex-end',
    padding: "".concat(8, "px ").concat(16, "px ").concat(8, "px"),
};
export var header = {
    borderBottom: "1px solid ".concat('#DFE4E8'),
    color: '#000000',
    display: 'flex',
    alignItems: 'center',
    fontWeight: 'bold',
    lineHeight: '24px',
    padding: 16,
    textDecoration: 'none',
    h3: {
        a: {
            i: {
                color: '#1454CC',
            },
        },
    },
};
export var collapsibleHeader = __assign({}, header);
export var headerLink = __assign(__assign({}, header), { color: "".concat('#1454CC', " !important"), alignSelf: 'flex-start', ':focus': {
        outline: "2px solid ".concat('#8e9aa4'),
        outlineOffset: 2,
        borderRadius: 12,
    }, div: {
        i: {
            color: '#1454CC',
        },
    } });
export var headerLinkIconLink = {
    div: {
        i: {
            color: "".concat('#1454CC', " !important"),
        },
    },
};
export var subHeader = {
    padding: "".concat(12, "px ").concat(16, "px 0"),
    fontSize: 14,
    color: '#323E48',
    fontWeight: '600',
};
export var title = {
    display: 'block',
    fontSize: 20,
    lineHeight: "".concat(24, "px"),
    flexGrow: 1,
    fontWeight: 'bold',
    margin: 0,
};
export var collapsibleTitle = __assign({}, title);
export var content = {
    color: '#000000',
    padding: "".concat(8, "px ").concat(16, "px"),
};
export var collapsibleContent = {
    padding: "".concat(8, "px ").concat(16, "px"),
};
export var contentSubHeader = __assign(__assign({}, content), { paddingTop: 8 });
export var actionArea = {};
export var icon = {
    background: '#E1E6EB',
    borderRadius: '50%',
    color: '#637380',
    display: 'inline-block',
    marginRight: 16,
    marginTop: 4 * -1,
    padding: 8,
    verticalAlign: 'middle',
};
